import { InjectionToken } from '@angular/core';
import { ValidAuthenticationResponse } from '@/app/platform/platform-core/user/services/types';

export const USER_ACTIVATOR = new InjectionToken<UserActivator>('');

export interface UserActivator {
  activateOnDesktop(
    authenticationResponse: ValidAuthenticationResponse,
    doRedirect?: boolean
  ): void;

  deactivate(redirectToLogin?: boolean): void;

  /** Vernieuwt het token meteen i.p.v. bij de volgende refresh-tick (bv. na een bevroren tab). */
  renewAuthentication(): Promise<void>;
}
